import createAxios from "./axiosHttp";

function getStopById(stopId) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopId}`;
  return axios.get(urlPath);
}

function updateStopDate(stopId, payload) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopId}/date`;
  return axios.patch(urlPath, payload);
}

function retryDelivery(stopIds, payload) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopIds}/retry`;
  return axios.put(urlPath, payload);
}

function updateStopAddressNormalized(stopId, payload) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopId}/address_normalized`;
  return axios.patch(urlPath, payload);
}

function updateStopTimeWindow(stopsIds, payload) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopsIds}/time_window`;
  return axios.patch(urlPath, payload);
}

function deleteStop(stopId) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopId}`;
  return axios.delete(urlPath);
}

function getUnassignedStops(date, type) {
  const axios = createAxios();
  const urlPath = "ttmm/stop";
  return axios.get(urlPath, { params: { date, type } });
}

function getStops(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/stop/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/stop/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getStopAudit(stopId) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopId}/audit`;
  return axios.get(urlPath);
}

function downloadManualExcelTemplate() {
  const axios = createAxios();
  const urlPath = "ttmm/stop/manual/excel";
  return axios.get(urlPath, { responseType: "arraybuffer" });
}

function createManualStop(payload) {
  const axios = createAxios();
  const urlPath = "ttmm/stop";
  return axios.post(urlPath, payload);
}

function updateManualStop(stopId, payload) {
  const axios = createAxios();
  const urlPath = `ttmm/stop/${stopId}`;
  return axios.put(urlPath, payload);
}

export const stopService = {
  getStopById,
  updateStopDate,
  retryDelivery,
  updateStopAddressNormalized,
  updateStopTimeWindow,
  deleteStop,
  getUnassignedStops,
  getStops,
  exportar,
  getStopAudit,
  downloadManualExcelTemplate,
  createManualStop,
  updateManualStop,
};
